import { useCallback, useContext } from "react";
import { useQuery } from "react-query";
import type { IGetAllOrdersByBookingIdParams } from "../domain";
import { UseQueryProps } from "../../interfaces";
import { apiServiceContext } from "../../api-service-context";
import { QueryKeys } from "../query-keys";

export const useGetAllOrdersByBookingId = <TData = any, TError = any>(
  params: IGetAllOrdersByBookingIdParams,
  queryOptions: UseQueryProps<TData, TError> = {}
) => {
  const { ordersApiService } = useContext(apiServiceContext);
  const queryFn = useCallback(
    () =>
      ordersApiService.createCancellableRequest((cancelToken) =>
        ordersApiService.getAllOrdersByBookingId(params, cancelToken)
      ),
    [ordersApiService, params]
  );

  return useQuery(QueryKeys.orders(params), queryFn, queryOptions);
};
